import { render, staticRenderFns } from "./permissionlisttable.vue?vue&type=template&id=235f1a0a&scoped=true&"
import script from "./permissionlisttable.vue?vue&type=script&lang=js&"
export * from "./permissionlisttable.vue?vue&type=script&lang=js&"
import style0 from "./permissionlisttable.vue?vue&type=style&index=0&id=235f1a0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f1a0a",
  null
  
)

export default component.exports